import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getPersonAddressDetails } from "./PersonAddressDetails";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class CommonResidency extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    let rows = [];
    if (props.reportData) {
      const reportAddresses = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].bpsReportAddresses[0].bpsReportAddress"
      );
      if (reportAddresses !== undefined && reportAddresses.length > 0) {
        rows = getPersonAddressDetails(props, reportAddresses, 0);
      }
      if (rows.length === 0) {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
  };

  render() {
    return (
      <SimpleAccordionContent
        id={`nav_${this.props.sectionName}`}
        {...this.props}
        name={"Common Residency"}
        rows={this.state.rows}
      />
    );
  }
}

export default CommonResidency;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/CommonResidency.js